// define public_path
// it will go to public folder
export const PUBLIC_PATH = process.env.PUBLIC_URL;



// WEBPACK FOOTER //
// ./src/Assets/js/constant.js